import type { NavigationGuard } from 'vue-router'
import { useAuthStore } from '@/store/auth'

/**
 * Requires the user to be authenticated. Auth is fully initialized in main.ts
 * boot() BEFORE the router is installed, so by the time any navigation runs the
 * store is already resolved — this guard only reads state, it never triggers
 * initialization (which previously cancelled the first navigation).
 */
export const authGuard: NavigationGuard = (_to, _from, next) => {
  const auth = useAuthStore()
  if (auth.isAuthenticated) {
    next()
  } else {
    // Not authenticated — Keycloak login-required handles the redirect.
    next(false)
  }
}

/**
 * Requires the super_admin role. Assumes authGuard runs first.
 */
export const superAdminGuard: NavigationGuard = (_to, _from, next) => {
  const auth = useAuthStore()
  if (auth.isSuperAdmin()) {
    next()
  } else {
    next(false)
  }
}
